import { LOCAL_STORAGE_TUNNEL_DATA_KEY } from "../../../core/service/BusinessLogicService"
import { getOrderByOPL } from "../../../service/OrderService"
import { useQuery } from "react-query"
import { useLocalStorage } from "react-use"

export default function useGetSimulationDataFromOPL(opl) {
  const [localTunnelData] = useLocalStorage(LOCAL_STORAGE_TUNNEL_DATA_KEY)

  const {
    data: order,
    isLoading: isLoadingOrder,
    refetch
  } = useQuery({
    queryKey: ["query-order", opl],
    queryFn: () => getOrderByOPL(localTunnelData, opl),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!opl
  })
  return { order, isLoadingOrder, refetch }
}
